import { useEffect, useState } from 'react';
import { localDateKey, msUntilNextLocalDay } from '../utils/travelState';

/** Refresh at local midnight and on resume (including a changed device timezone). */
export function useLocalDate() {
  const [date, setDate] = useState(localDateKey);
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const refresh = () => {
      setDate(localDateKey());
      clearTimeout(timer);
      timer = setTimeout(refresh, msUntilNextLocalDay());
    };
    refresh();
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, []);
  return date;
}
